import React from 'react';
import { useParams } from 'react-router-dom';
import './App.css';
import PSPDFKit from './containers/pspdfkit';
import 'bootstrap/dist/css/bootstrap.css';

const baseUrl = `${window.location.protocol}//${window.location.host}/${
  process.env.PUBLIC_URL
}`;

function App() {
  const { client, superid } = useParams();

  console.log('app 1 start');
  let exportPdfUrl = `https://${client}/export.pdf?superid=${superid}`;
  if (process.env.NODE_ENV === 'development') {
    console.log('In dev using local pdf.');
    exportPdfUrl = '/test/test.pdf';
  }

  return (
    <div className="App">
      <PSPDFKit
        pdfUrl={exportPdfUrl}
        licenseKey={process.env.REACT_APP_PSPDFKIT_LICENSE}
        baseUrl={baseUrl}
      />
    </div>
  );
}

export default App;
